import createStyles from "@material-ui/core/styles/createStyles";
import { Theme } from "@material-ui/core";

export const styles = ({spacing, palette}: Theme) => createStyles({
    container: {
        width: "100vw",
        height: "100vh",
        minWidth: "800px", 
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: `url(${require("./background2.jpg")}) no-repeat`,
        backgroundSize: "cover",
        backgroundPosition: "center"
    }
});


// WEBPACK FOOTER //
// ./src/components/Background/Background.style.tsx